// extracted by mini-css-extract-plugin
module.exports = {"infoIconContainer":"EditActuatorForm_infoIconContainer__1Xvih","infoIcon":"EditActuatorForm_infoIcon__2XzDH"};